"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _siteLogo = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/logos/site-logo.svg"));
var _symbol = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/logos/symbol.svg"));
var _core = require("core.ui-module_site-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SiteHeading = _ref => {
  let {
    homePath,
    siteTitle,
    siteSubTitle,
    coBrand,
    logo,
    logoAlt,
    logoSize,
    isBrandingColorWheel
  } = _ref;
  let siteLogo = typeof logo !== 'undefined' ? logo : _siteLogo.default;
  siteLogo = typeof logo === 'undefined' && logoSize === 'small' ? _symbol.default : siteLogo;
  siteLogo = isBrandingColorWheel ? _symbol.default : siteLogo;
  let siteLogoSize = logoSize || 'normal';
  siteLogoSize = isBrandingColorWheel ? 'small' : siteLogoSize;
  siteLogoSize = siteLogoSize === 'none' ? 'no' : siteLogoSize;
  const title = coBrand || siteTitle;
  const titleSize = title && title.length >= 18 ? 'has-title-long' : 'has-title-normal';
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: homePath,
    className: "navbar-link logo section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `site-name columns is-gapless is-vcentered ${siteLogoSize}-logo`
  }, siteLogoSize !== 'no' && /*#__PURE__*/_react.default.createElement("div", {
    className: "column site-logo-container is-narrow"
  }, /*#__PURE__*/_react.default.createElement("img", {
    id: "site-logo",
    src: siteLogo,
    alt: logoAlt
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "column site-title-container"
  }, /*#__PURE__*/_react.default.createElement(_core.Title, {
    text: title,
    className: titleSize
  }), siteSubTitle && siteSubTitle.trim().length > 0 && !coBrand && /*#__PURE__*/_react.default.createElement(_core.Title, {
    text: siteSubTitle
  }))));
};
SiteHeading.propTypes = {
  homePath: _propTypes.default.string,
  siteTitle: _propTypes.default.string,
  siteSubTitle: _propTypes.default.string,
  coBrand: _propTypes.default.string,
  logoAlt: _propTypes.default.string,
  logo: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  logoSize: _propTypes.default.string,
  isBrandingColorWheel: _propTypes.default.bool
};
SiteHeading.defaultProps = {
  homePath: '/home.html',
  siteTitle: '',
  siteSubTitle: '',
  logoAlt: 'MissionSquare Retirement',
  logoSize: 'normal'
};
var _default = exports.default = SiteHeading;
//# sourceMappingURL=SiteHeading.js.map